import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  Container,
  CardContent,
  Divider,
  Card,
  Table,
  Grid,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Collapse,
  TextField,
} from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import Paper from "@mui/material/Paper";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CardHeader1 from "../../LabManager/LabHeader";
import { CopyToClipboard } from "react-copy-to-clipboard";
import IconButton from "@mui/material/IconButton";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import StartLab from "../Actions/Startlab";
import StopLab from "../Actions/Stoplab";
import StopTwoToneIcon from "@mui/icons-material/StopTwoTone";
import PlayArrowTwoToneIcon from "@mui/icons-material/PlayArrowTwoTone";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import Grafana from "../Actions/Grafana";
import moment from "moment";
import Refresh from "../Actions/Reload";
import WarningAlert from "../Alert/WarningAlert";
import NotToDo from "../Actions/NotToDo";


const ensureAbsoluteUrl = (url) => {
  if (!url) return '#'; // Fallback in case URL is null or undefined
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `http://${url}`;
  }
  return url;
};


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#b5b6b7",
    display: "flex",
    height: 280,
  },
  tabs: {
    borderRight: `1px solid`,
    overflow: `visible`,
  },
  title: {
    fontSize: 14,
  },
}));

const Detail = () => {

  const [expandedRow, setExpandedRow] = useState(null);
  const [validerroropen, setValidErrorOpen] = useState(false); // <-- modal state

  const handleExpandRow = (rowName) => {
    if (rowName === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowName);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function DateTime1(startDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startDate1 = new Date(startDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const startDate2 = startDate1.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-");

    return startDate3;
  }

  function DateTime21(endDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-");
    return endDate3;
  }

  function DateTime2(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-");
    return endDate3;
  }


  function DateTime3(startDate, startTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const startTime1 = new Date(
      startDate + "T" + startTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);
    return startTime3;
  }

  function DateTime4(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(
      endDate + "T" + endTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);
    return endTime3;
  }

  const [value, setValue] = React.useState("");

  // const handleChange = (event) => {
  //   setValue(String(event.target.value));
  // };

  // useEffect(() => {
  //   setExpandedRow("");
  // }, [value])

  const [selectedTrainee, setSelectedTrainee] = useState('');
  const handleChange = (event) => {
    setSelectedTrainee(event.target.value);
  };

  useEffect(() => {
    setExpandedRow("");
  }, [selectedTrainee])

  const [feedbackResponse, setFeedbackResponse] = useState([]);
  const [instancelist, setinstancelist] = useState([]);
  const [openAssessmentDialog, setOpenAssessmentDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  // const [depends_On, setDependsOn] = useState('');
  // const [manage_Labs, setManageLabs] = useState('');
  useEffect(() => {
    const InstanceID = localStorage.getItem("InstanceID");
    const instanceLabType = "cloud"
    fetch(
      `${process.env.REACT_APP_API_URL}/api/traineeclouddetails/${InstanceID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setinstancelist(data);
          // const depends_on = data.map(item => item.depends_on)
          // setDependsOn(depends_on[0]);
          // const manage_labs = data.map(item => item.manage_labs)
          // setManageLabs(manage_labs[0]);

          const trainee_id = data.map(item => item.trainee_id)
          const end_date = data.map(item => item.end_date)
          const stop_time = data.map(item => item.stop_time)
          // setPopupStatus(data[0]?.popup_status || "");
          if (data[0]?.popup_status === "no" || data[0]?.popup_status === "" || data[0]?.popup_status === "None") {
            setValidErrorOpen(true);
          }

          if (trainee_id !== "" && end_date !== "" && stop_time !== "") {
            fetch(`${process.env.REACT_APP_API_URL}/api/traineefeedbackdetails/`, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
              .then((resp) => resp.json())
              .then((data) => {
                if (data.detail) {
                } else {
                  setFeedbackResponse(data);
                  if (data === "No Feedback found") {
                    setOpenDialog(true);
                  } else {
                    setOpenDialog(false);
                    // console.log("steep -2  --> ");
                    if (!feedbackResponse || feedbackResponse.length === 0) {
                      fetch(`${process.env.REACT_APP_API_URL}/api/verifyquizinformation/`, {
                        method: 'GET',
                        headers: {
                          'Content-Type': 'application/json',
                          Authorization: 'Bearer ' + localStorage.getItem('token'),
                        },
                      })
                        .then((resp) => resp.json())
                        .then((data) => {
                          if (data.detail) {
                            // Handle if detail is present
                          } else {
                            if (data === "No Assessment found") {
                              setOpenAssessmentDialog(true);
                            } else {
                              setOpenAssessmentDialog(false);
                            }
                          }
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                    }
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              });
          }

        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log(instancelist);

  function timeDiff(endDate, endTime, startDate, startTime, dependsOn, manageLabs) {
    const nowTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);

    const startTime1 = new Date(startDate + "T" + startTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);

    const endTimeMoment = moment(endTime3, 'HH:mm');
    const currentTimeMoment = moment(nowTime, 'HH:mm');

    const diffInMinutes = endTimeMoment.diff(currentTimeMoment, 'minutes');
    let disable = true;

    const labEndDate = moment(endDate).format('DD-MM-YYYY');
    var currentDate = new Date().toISOString().substring(0, 10);


    // console.log("step-1")
    // console.log("Total-Difference", diffInMinutes)
    // console.log("currentDate", DateTime2(currentDate))
    // console.log("labEndDate", labEndDate)
    // console.log("current_time", nowTime)
    // console.log("end_time", endTimeMoment)
    if (dependsOn === "immediate" || dependsOn === "always") {
      if (DateTime21(currentDate) == labEndDate) {
        if (diffInMinutes > 0 && diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`) {
          disable = true;
        }
        else if (diffInMinutes <= 0) {
          disable = true;
        }
        else {
          disable = false;
        }
      }
      else {
        if (new Date(currentDate) <= new Date(endDate)) {
          disable = false;
        }
        else {
          disable = true;
        }
      }
    }
    else if (dependsOn === "during_training") {
      if (diffInMinutes > 0 && diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`) {
        disable = true;
        return disable;
      } else if (currentTimeMoment.isSameOrAfter(moment(startTime3, 'HH:mm')) && currentTimeMoment.isSameOrBefore(moment(endTime3, 'HH:mm'))) {
        disable = false;
        // return disable;       
      } else if (dependsOn === "during_training" && manageLabs === "yes") {
        disable = false;
        return disable;
      } else if (dependsOn === "during_training" && manageLabs === "no" && currentTimeMoment.isAfter(moment(endTime3, 'HH:mm'))) {
        disable = true;
      }
    }
    return disable;
  }

  const [opendelete, setOpendelete] = React.useState(false);
  const handleClickOpenDelete = () => {
    setOpendelete(true);
  };

  const handleCloseDelete = () => {
    setOpendelete(false);
  };

  const Delete = () => {
    return function () {
      window.location.href = "/app/instance";
      const InstanceID = localStorage.getItem("InstanceID");
      fetch(
        `${process.env.REACT_APP_API_URL}/api/manageCloudlabs/${InstanceID}/`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          handleCloseDelete();
        })
        .catch((error) => {
          handleCloseDelete();
        });
      handleCloseDelete();
    };
  };

  const [openLog, setOpenLog] = React.useState(false);

  const handleClickOpenLog = () => {
    setOpenLog(true);
  };

  const handleCloseLog = () => {
    setOpenLog(false);
  };

  const handleLogOk = () => {
    setOpenLog(false);
  };


  const [showPassword, setShowPassword] = useState(false);

  const handleIconClick = () => {
    setShowPassword(!showPassword);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose1 = () => {
    setAnchorEl(null);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    window.location.href = '/app/feedback';
  };

  const handleAssessmentDialog = () => {
    setOpenAssessmentDialog(false);
    window.location.href = '/app/assessmentlist';
  };

  const open1 = Boolean(anchorEl);
  const id = open1 ? "simple-popover" : undefined;
  const [copied, setCopied] = React.useState(false);

  return (
    <>
      <WarningAlert
        validerroropen={validerroropen}
        setvaliderroropen={setValidErrorOpen}
        alertLabType={"cloud"}
      />
      <Dialog
        open={openDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Pending Feedback Notification!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please ensure that all feedback submissions are completed before proceeding
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAssessmentDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Pending Assessment Notification!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please ensure that all assessment submissions are completed before proceeding.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAssessmentDialog} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {instancelist.map((instancelist) => (
        <React.Fragment>
          <Helmet>
            <title>LabAsService</title>
          </Helmet>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 3,
            }}
          >
            <div
              style={{ alignItems: "center", display: "flex", width: "600px" }}
            >
              <Dialog
                open={opendelete}
                onClose={handleCloseDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Are you sure you want to delete the Lab{" "}
                  <strong style={{ color: "#EF5350" }}>
                    {instancelist.name}
                  </strong>{" "}
                  ?
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description"></DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseDelete} color="primary">
                    Disagree
                  </Button>
                  <Button onClick={Delete()} color="primary" autoFocus>
                    Agree
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={openLog}
                onClose={handleCloseLog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Activity Log
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Hello
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {/* <Button onClick={handleCloseDelete} color="primary">
                    Disagree
                  </Button> */}
                  <Button onClick={handleLogOk} color="primary" autoFocus>
                    OK
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <NotToDo/>
              <Refresh />
              {instancelist.trainee_labstatus === "Stopped" ? (
                <StartLab traineetag={instancelist.trainee_id} endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} startDate={`${instancelist.start_date}`}
                  startTime={`${instancelist.start_time}`} depends_on={`${instancelist.depends_on}`} manage_labs={`${instancelist.manage_labs}`} startcron={`${instancelist.startcron_expression}`} startcron1={`${instancelist.startcron_expression2}`} labType={"cloud"} />
              ) : instancelist.trainee_labstatus === "Active" ? (
                <React.Fragment>
                  {/* <ReportEX pccreportdataset={pccreportdataset} /> */}
                  <StopLab traineetag={instancelist.trainee_id} endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} startDate={`${instancelist.start_date}`}
                    startTime={`${instancelist.start_time}`} depends_on={`${instancelist.depends_on}`} manage_labs={`${instancelist.manage_labs}`} labType={"cloud"} />
                </React.Fragment>
              ) : instancelist.trainee_labstatus === "Stop Initiated" ? (
                <Button
                  sx={{
                    mx: 1,
                    width: '150px',
                    height: '30px',
                    marginRight: "30px",
                    marginBottom: "5px",
                    marginTop: "-15px",
                  }}
                  style={{ whiteSpace: 'nowrap' }}
                  variant="outlined"
                  color="primary"
                  startIcon={<StopTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                    `${instancelist.start_time}`, `${instancelist.depends_on}`, `${instancelist.manage_labs}`)}
                >
                  Stop Initiated
                </Button>
              ) : instancelist.trainee_labstatus === "Start Initiated" ? (
                <Button
                  sx={{
                    mx: 1,
                    width: '150px',
                    height: '30px',
                    marginRight: "30px",
                    marginBottom: "5px",
                    marginTop: "-15px",
                  }}
                  style={{ whiteSpace: 'nowrap' }}
                  variant="outlined"
                  color="primary"
                  startIcon={<PlayArrowTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                    `${instancelist.start_time}`, `${instancelist.depends_on}`, `${instancelist.manage_labs}`)}
                >
                  Start Initiated
                </Button>
              ) : instancelist.trainee_labstatus === "Stopping" ? (
                <Button
                  sx={{
                    mx: 1,
                    width: '140px',
                    height: '30px',
                    marginRight: "30px",
                    marginBottom: "5px",
                    marginTop: "-15px",
                  }}
                  variant="outlined"
                  color="primary"
                  startIcon={<StopTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                    `${instancelist.start_time}`, `${instancelist.depends_on}`, `${instancelist.manage_labs}`)}
                >
                  Stopping
                </Button>
              ) : instancelist.trainee_labstatus === "Starting" ? (
                <Button
                  sx={{
                    mx: 1,
                    width: '140px',
                    height: '30px',
                    marginRight: "30px",
                    marginBottom: "5px",
                    marginTop: "-15px",
                  }}
                  variant="outlined"
                  color="primary"
                  startIcon={<PlayArrowTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                    `${instancelist.start_time}`, `${instancelist.depends_on}`, `${instancelist.manage_labs}`)}
                >
                  Starting
                </Button>
              ) : (
                ""
              )}
            </Box>
            <CardHeader1
              color="primary"
              style={{
                background:
                  "-webkit-linear-gradient(left top, #444458, #7e4aaf)",
                background:
                  "linear-gradient(to bottom right, #444458, #7e4aaf)",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "5px",
                marginTop: "-50px",
                height: '40px',
              }}
            >
              <Typography fontWeight="fontWeightBold" color="white" variant="h6" style={{ whiteSpace: 'nowrap', marginBottom: "-5px", }}>
                Lab Name: <strong>{instancelist.name}</strong>
              </Typography>
            </CardHeader1>
            <Container maxWidth={false}>
              <Box border={0} sx={{ mt: 1 }}>
                <Card>
                  <CardContent>
                    <Typography
                      color="textPrimary"
                      variant="h6"
                      gutterBottom
                      marginTop={-1}
                    >
                      Details
                    </Typography>
                    <div>
                      <TableContainer component={Paper}>
                        <Table size="small" aria-label="simple table">
                          <TableBody>
                            <TableRow key="name">
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  CodeShare : <Button size="small" style={{ height: "25px" }} variant="outlined" target="_blank" endIcon={<OpenInNewIcon style={{ height: "15px" }} />} href={instancelist.codeshare}>
                                    Open
                                  </Button>
                                  <CopyToClipboard
                                    text={instancelist.codeshare}
                                    onCopy={() => setCopied(true)}
                                  >
                                    <IconButton
                                      aria-label="Filter"
                                      color="primary"
                                      onClick={handleClick}
                                      style={{ height: "25px" }}
                                    >
                                      <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                    </IconButton>
                                  </CopyToClipboard>
                                  <Popover
                                    id={id}
                                    open={open1}
                                    anchorEl={anchorEl}
                                    onClose={handleClose1}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        color: "forestgreen",
                                      }}
                                    >
                                      Copied!.
                                    </Typography>
                                  </Popover>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{
                                    display: "inline-block",
                                  }}
                                  gutterBottom
                                >
                                  Status : <span style={{ fontWeight: "normal" }}>{instancelist.status}</span>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  No of Trainees : <span style={{ fontWeight: "normal" }}>{instancelist.no_of_trainee}</span>
                                </Typography>
                              </TableCell>
                              {/* <TableCell align="left">
                            <Typography
                                variant="h6"
                                fontWeight="fontWeightBold"
                                style={{ display: "inline-block" }}
                                gutterBottom                                  
                            >Budget : <span style={{ fontWeight: "normal" }}>{`${instancelist.budget_amount}`}</span> </Typography>
                            </TableCell> */}
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Schedule : <span style={{ fontWeight: "normal" }}>{`${instancelist.depends_on}`}</span>
                                </Typography>
                              </TableCell>
                            </TableRow>
                            <TableRow key="name">
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Start Date : <span style={{ fontWeight: "normal" }}>{DateTime1(`${instancelist.start_date}`)}</span>
                                </Typography>
                              </TableCell>
                              {instancelist.start_time == "" ||
                                instancelist.start_time == null ? (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Start Time : <span style={{ fontWeight: "normal" }}>NA</span>
                                  </Typography>
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Start Time : <span style={{ fontWeight: "normal" }}>{DateTime3(`${instancelist.start_date}`, `${instancelist.start_time}`)}</span>
                                  </Typography>
                                </TableCell>
                              )}
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  End Date : <span style={{ fontWeight: "normal" }}>{DateTime2(`${instancelist.end_date}`, `${instancelist.stop_time}`)}</span>
                                </Typography>
                              </TableCell>

                              {instancelist.stop_time == "" ||
                                instancelist.stop_time == null ? (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Stop Time : <span style={{ fontWeight: "normal" }}>NA</span>
                                  </Typography>
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    End Time : <span style={{ fontWeight: "normal" }}>{DateTime4(`${instancelist.end_date}`, `${instancelist.stop_time}`)}</span>
                                  </Typography>
                                </TableCell>
                              )}
                            </TableRow>
                            <TableRow key="meetingurl">
                              <TableCell align="left" component="th" scope="row">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Meeting Link:
                                  <a
                                    href={ensureAbsoluteUrl(instancelist.meeting_url)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'underline', color: 'blue', marginLeft: '10px' }}
                                  >
                                    {instancelist.meeting_url}
                                  </a>
                                  <CopyToClipboard
                                    text={instancelist.meeting_url}
                                    onCopy={() => setCopied(true)}
                                  >
                                    <IconButton
                                      aria-label="Filter"
                                      color="primary"
                                      onClick={handleClick}
                                      style={{ height: "25px" }}
                                    >
                                      <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                    </IconButton>
                                  </CopyToClipboard>
                                  <Popover
                                    id={id}
                                    open={open1}
                                    anchorEl={anchorEl}
                                    onClose={handleClose1}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                  >
                                    <Typography style={{ color: "forestgreen" }}>
                                      Copied!.
                                    </Typography>
                                  </Popover>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </CardContent>
                </Card>
              </Box>
              <Divider />
              <Box border={0} sx={{ mt: 1 }} paddingBottom={0} paddingTop={0}>
                <Card>
                  <Typography
                    color="textPrimary"
                    variant="h6"
                    gutterBottom
                    style={{ marginLeft: "20px", marginTop: '10px' }}
                  >
                    Instance Details
                    <Divider />
                  </Typography>
                  <PerfectScrollbar>
                    <Card>
                      <CardContent>
                        {instancelist.details.map((instance_info, i) => {
                          const traineeid = i + 1;
                          return (
                            <React.Fragment key={traineeid}>
                              <TabPanel>
                                <Grid
                                  container
                                  spacing={1}
                                  marginTop={-5}
                                  marginBottom={-0.5}
                                  marginLeft={0}
                                >
                                  <Grid item xs={12} marginLeft={0}>
                                    <Typography
                                      style={{ display: "inline-block" }}
                                      gutterBottom
                                    >
                                      Assigned user :
                                    </Typography>
                                    <Typography
                                      fontWeight={500}
                                      marginLeft={1}
                                      style={{ display: "inline-block" }}
                                      gutterBottom
                                    >
                                      {instance_info.email}
                                    </Typography>
                                  </Grid>

                                </Grid>
                                <TableContainer component={Paper}>
                                  <Table
                                    size="small"
                                    // style={{ width: 1215 }}
                                    aria-label="a dense table"
                                  >
                                    <TableHead
                                      style={{ backgroundColor: "#06396c", }}
                                    >
                                      <TableRow sx={{ height: '30px' }}>
                                        <TableCell />
                                        <TableCell
                                          style={{ color: "#ffffff" }}
                                          align="left"
                                        >
                                          Name
                                        </TableCell>
                                        <TableCell
                                          style={{ color: "#ffffff" }}
                                          align="left"
                                        >
                                          Provider
                                        </TableCell>
                                        <TableCell
                                          style={{ color: "#ffffff", paddingRight: '10px' }}
                                          align="left"
                                        >
                                          Console Panel
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {instancelist.details.map((details, index) => (
                                        <React.Fragment key={`Trainee-${index + 1}`}>
                                          <TableRow>
                                            <TableCell>
                                              <IconButton
                                                size="small"
                                                onClick={() => handleExpandRow(`Trainee-${index + 1}`)}
                                              >
                                                {expandedRow === `Trainee-${index + 1}` ? (
                                                  <KeyboardArrowUp />
                                                ) : (
                                                  <KeyboardArrowDown />
                                                )}
                                              </IconButton>
                                            </TableCell>
                                            <TableCell style={{ paddingLeft: '10px' }} align="left">{`Trainee-${index + 1}`}</TableCell>
                                            <TableCell style={{ paddingLeft: '30px' }} align="left">{instancelist.provider}</TableCell>
                                            <TableCell align="left" colSpan={3}>
                                              <Button
                                                size="small"
                                                variant="contained"
                                                target="_blank"
                                                endIcon={<OpenInNewIcon style={{ height: "15px" }} />}
                                                href={instancelist.provider === "Azure" ? "https://portal.azure.com/" : `https://${details.account_id}.signin.aws.amazon.com/console`}
                                                style={{ height: "25px" }}
                                                // disabled={ (details.status === "Active") ? false : timeDiff(`${instancelist.end_date}`,`${instancelist.stop_time}`,`${instancelist.start_date}`,`${instancelist.start_time}`,instancelist.depends_on,instancelist.manage_labs) }
                                                disabled={(instancelist.status === "Active") ? false : true}
                                              >
                                                Connect
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              style={{ paddingBottom: 0, paddingTop: 0 }}
                                              colSpan={4}
                                            >
                                              <Collapse
                                                in={expandedRow === `Trainee-${index + 1}`}
                                                timeout="auto"
                                                unmountOnExit
                                              >
                                                <div>
                                                  {/* Content to display when row is expanded */}
                                                  <TableRow>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px' }}>
                                                      <strong>Account Id :</strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="left">
                                                      {details.account_id}
                                                      <CopyToClipboard
                                                        text={details.account_id}
                                                        onCopy={() => setCopied(true)}
                                                      >
                                                        <IconButton
                                                          aria-label="Filter"
                                                          color="primary"
                                                          onClick={handleClick}
                                                        >
                                                          <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                        </IconButton>
                                                      </CopyToClipboard>
                                                      <Popover
                                                        id={id}
                                                        open={open1}
                                                        anchorEl={anchorEl}
                                                        onClose={handleClose1}
                                                        anchorOrigin={{
                                                          vertical: "bottom",
                                                          horizontal: "center",
                                                        }}
                                                        transformOrigin={{
                                                          vertical: "top",
                                                          horizontal: "center",
                                                        }}
                                                      >
                                                        <Typography
                                                          style={{ color: "forestgreen" }}
                                                        >
                                                          Copied!.
                                                        </Typography>
                                                      </Popover>
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '-20px' }}>
                                                      <strong>Account Username : </strong>
                                                    </TableCell>
                                                    <TableCell
                                                      align="left"
                                                      component="th"
                                                      scope="row"
                                                      style={{ whiteSpace: 'nowrap' }}
                                                    >
                                                      <Typography
                                                        variant="h6"
                                                        fontWeight="fontWeightBold"
                                                        style={{ display: "inline-block" }}
                                                        gutterBottom
                                                      >
                                                        {instancelist.provider === "Azure"
                                                          ? details.account_name
                                                          : instancelist.username}
                                                      </Typography>
                                                      <CopyToClipboard
                                                        text={instancelist.username}
                                                        onCopy={() => setCopied(true)}
                                                      >
                                                        <IconButton
                                                          aria-label="Filter"
                                                          color="primary"
                                                          onClick={handleClick}

                                                        >
                                                          <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                        </IconButton>
                                                      </CopyToClipboard>
                                                      <Popover
                                                        id={id}
                                                        open={open1}
                                                        anchorEl={anchorEl}
                                                        onClose={handleClose1}
                                                        anchorOrigin={{
                                                          vertical: "bottom",
                                                          horizontal: "center",
                                                        }}
                                                        transformOrigin={{
                                                          vertical: "top",
                                                          horizontal: "center",
                                                        }}
                                                      >
                                                        <Typography style={{ color: "forestgreen" }}>
                                                          Copied!.
                                                        </Typography>
                                                      </Popover>
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '-20px' }}>
                                                      <strong>Account Password : </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="left">
                                                      {showPassword ? (
                                                        <Typography
                                                          variant="h6"
                                                          fontWeight="fontWeightBold"
                                                          style={{ display: "inline-block", marginLeft: "5px" }}
                                                          gutterBottom
                                                        >
                                                          {`${instancelist.initialpassword}`}
                                                        </Typography>
                                                      ) : (
                                                        <Typography
                                                          variant="h6"
                                                          fontWeight="fontWeightBold"
                                                          style={{ display: "inline-block", marginLeft: "5px" }}
                                                          gutterBottom
                                                        >
                                                          {"******"}
                                                        </Typography>
                                                      )}
                                                      <IconButton
                                                        aria-label="Toggle Password Visibility"
                                                        color="primary"
                                                        onClick={handleIconClick}
                                                      >
                                                        {showPassword ? (
                                                          <VisibilityOffIcon style={{ marginLeft: "10px", fontSize: "20px" }} />
                                                        ) : (
                                                          <VisibilityIcon style={{ marginLeft: "10px", fontSize: "20px" }} />
                                                        )}
                                                      </IconButton>
                                                      <CopyToClipboard
                                                        text={instancelist.initialpassword}
                                                        onCopy={() => setCopied(true)}
                                                      >
                                                        <IconButton
                                                          aria-label="Copy"
                                                          color="primary"
                                                          onClick={handleClick}
                                                        >
                                                          <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                        </IconButton>
                                                      </CopyToClipboard>
                                                      <Popover
                                                        id={id}
                                                        open={open1}
                                                        anchorEl={anchorEl}
                                                        onClose={handleClose1}
                                                        anchorOrigin={{
                                                          vertical: "bottom",
                                                          horizontal: "center",
                                                        }}
                                                        transformOrigin={{
                                                          vertical: "top",
                                                          horizontal: "center",
                                                        }}
                                                      >
                                                        <Typography style={{ color: "forestgreen" }}>
                                                          Copied!.
                                                        </Typography>
                                                      </Popover>
                                                    </TableCell>

                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px' }}>
                                                      <strong>Account Name : </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="left">{details.account_name}</TableCell>
                                                    <TableCell component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '-20px' }}>
                                                      <strong>Console URL : </strong>
                                                    </TableCell>
                                                    {instancelist.provider === "Azure" ? (
                                                      <TableCell style={{ whiteSpace: 'nowrap', fontSize: '12px' }} align="left">
                                                        https://portal.azure.com/
                                                        <CopyToClipboard
                                                          text="https://portal.azure.com/"
                                                          onCopy={() => setCopied(true)}
                                                        >
                                                          <IconButton
                                                            aria-label="Filter"
                                                            color="primary"
                                                            onClick={handleClick}
                                                          >
                                                            <FileCopyOutlinedIcon />
                                                          </IconButton>
                                                        </CopyToClipboard>
                                                        <Popover
                                                          id={id}
                                                          open={open1}
                                                          anchorEl={anchorEl}
                                                          onClose={handleClose1}
                                                          anchorOrigin={{
                                                            vertical: "bottom",
                                                            horizontal: "center",
                                                          }}
                                                          transformOrigin={{
                                                            vertical: "top",
                                                            horizontal: "center",
                                                          }}
                                                        >
                                                          <Typography
                                                            style={{ color: "forestgreen" }}
                                                          >
                                                            Copied!.
                                                          </Typography>
                                                        </Popover>
                                                      </TableCell>
                                                    ) : instancelist.provider === "Gcp" ? (
                                                      <TableCell style={{ whiteSpace: 'nowrap', fontSize: '12px' }} align="left">
                                                        https://console.cloud.google.com/
                                                        <CopyToClipboard
                                                          text="https://console.cloud.google.com/"
                                                          onCopy={() => setCopied(true)}
                                                        >
                                                          <IconButton
                                                            aria-label="Filter"
                                                            color="primary"
                                                            onClick={handleClick}
                                                          >
                                                            <FileCopyOutlinedIcon />
                                                          </IconButton>
                                                        </CopyToClipboard>
                                                        <Popover
                                                          id={id}
                                                          open={open1}
                                                          anchorEl={anchorEl}
                                                          onClose={handleClose1}
                                                          anchorOrigin={{
                                                            vertical: "bottom",
                                                            horizontal: "center",
                                                          }}
                                                          transformOrigin={{
                                                            vertical: "top",
                                                            horizontal: "center",
                                                          }}
                                                        >
                                                          <Typography
                                                            style={{ color: "forestgreen" }}
                                                          >
                                                            Copied!.
                                                          </Typography>
                                                        </Popover>
                                                      </TableCell>
                                                    ) : (
                                                      <TableCell style={{ whiteSpace: 'nowrap', fontSize: '12px' }} align="left">
                                                        https://{details.account_id}
                                                        .signin.aws.amazon.com/console
                                                        <CopyToClipboard
                                                          text={`https://${details.account_id}.signin.aws.amazon.com/console`}
                                                          onCopy={() => setCopied(true)}
                                                        >
                                                          <IconButton
                                                            aria-label="Filter"
                                                            color="primary"
                                                            onClick={handleClick}
                                                          >
                                                            <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                          </IconButton>
                                                        </CopyToClipboard>
                                                        <Popover
                                                          id={id}
                                                          open={open1}
                                                          anchorEl={anchorEl}
                                                          onClose={handleClose1}
                                                          anchorOrigin={{
                                                            vertical: "bottom",
                                                            horizontal: "center",
                                                          }}
                                                          transformOrigin={{
                                                            vertical: "top",
                                                            horizontal: "center",
                                                          }}
                                                        >
                                                          <Typography
                                                            style={{ color: "forestgreen" }}
                                                          >
                                                            Copied!.
                                                          </Typography>
                                                        </Popover>
                                                      </TableCell>
                                                    )}
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '-20px' }}>
                                                      <strong>Usage Report : </strong>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                      <Grafana
                                                        index_name={details.account_id}
                                                        analytics_panel_id={
                                                          details.analytics_panel_id
                                                        }
                                                      />
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px' }}>
                                                      <strong>Activity Log : </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="left">
                                                      <Button
                                                        sx={{
                                                          mx: 1,
                                                          width: '85px',
                                                          height: '25px',
                                                        }}
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleClickOpenLog}
                                                      >
                                                        Log
                                                      </Button>
                                                    </TableCell>
                                                  </TableRow>
                                                </div>
                                              </Collapse>
                                            </TableCell>
                                          </TableRow>
                                        </React.Fragment>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </TabPanel>
                            </React.Fragment>
                          );
                        })}
                      </CardContent>
                    </Card>
                  </PerfectScrollbar>
                </Card>
              </Box>
            </Container>
          </Box>
        </React.Fragment>
      ))}
    </>
  );
};

export default Detail;